import React from "react";
import PropTypes from "prop-types";

const PageSizeOptions = ({ pageSize, onChange }) => {
  const pageSizes = [2, 5, 10, 25, 50, 100];
  return (
    <div className="form-inline">
      <span className="mr-2">Page Size</span>
      <select
        className="form-control form-control-sm"
        value={pageSize}
        onChange={onChange}
        aria-label="Select Pagesize"
      >
        {pageSizes.map((size) => (
          <option value={size}>{size}</option>
        ))}
      </select>
      <span className="ml-2">Rows</span>
    </div>
  );
};

PageSizeOptions.propTypes = {};

export default PageSizeOptions;
